/**
 * Utility per integrazione BOGOS app
 * Gestisce le offerte regalo basate su soglie di spesa
 */
(function() {
  'use strict';
  
  // Attendi che FGSECOMAPP sia disponibile
  const initBogosHelper = () => {
    if (!window.FGSECOMAPP?.offers) {
      setTimeout(initBogosHelper, 100);
      return;
    }

    window.bogosHelper = {
      // Config e state rimangono invariati
      config: {
        endpoints: {
          cart: '/cart.js',
          bogos: '/apps/bogo'
        }
      },

      state: {
        lastCartTotal: 0,
        currentOffer: null
      },

      // Analisi offerte BOGOS
      findNextThreshold(cartTotal) {
        const offers = window.FGSECOMAPP.offers;
        let nextOffer = null;
        let requiredAmount = 0;

        offers.forEach(offer => {
          const conditions = offer.offer_conditions?.[0] || {};
          const minAmount = conditions.unit === "money" ? 
            conditions.min_amount : 
            0;

          if (minAmount > cartTotal && (!requiredAmount || minAmount < requiredAmount)) {
            nextOffer = offer;
            requiredAmount = minAmount;
          }
        });

        return nextOffer ? { offer: nextOffer, requiredAmount } : null;
      },

      // Recupera prodotti regalo
      getGiftProducts(offer) {
        const gifts = [];
        
        if (offer.gift_products) {
          gifts.push(...offer.gift_products.map(product => ({
            title: product.title,
            id: product.product_shopify_id,
            variants: product.variants
          })));
        }

        if (offer.gift_collections) {
          offer.gift_collections.forEach(collection => {
            if (collection.products) {
              gifts.push(...collection.products.map(product => ({
                title: product.title,
                id: product.product_shopify_id,
                variants: product.variants
              })));
            }
          });
        }

        return gifts;
      },

      // Analizza e formatta messaggio BOGOS
      analyzeBogosOffer(cartTotal) {
        const nextThreshold = this.findNextThreshold(cartTotal);
        if (!nextThreshold) return '';

        const { offer, requiredAmount } = nextThreshold;
        const missingAmount = requiredAmount - cartTotal;
        const gifts = this.getGiftProducts(offer);
        
        if (!gifts.length) return '';

        this.state.currentOffer = offer;
        this.state.lastCartTotal = cartTotal;

        const giftsList = gifts.map(gift => gift.title).join(', ');
        return `Ti mancano ${missingAmount.toFixed(2)}€ per ricevere in regalo: ${giftsList}`;
      }
    };

    // Notifica che bogosHelper è pronto
    document.dispatchEvent(new Event('bogoshelper:ready'));
  };

  // Avvia inizializzazione
  initBogosHelper();
})();